// Localização: frontend/src/components/Prontuario/Profissional/ProfissionalDadosPessoaisTab.jsx (versão 1.0.0)
// Aba de Dados Pessoais do prontuário do profissional

import React from 'react';
import { formatDate } from '../../../utils/formatters';

const ProfissionalDadosPessoaisTab = ({ profissionalId, prontuarioData, onRefresh }) => {
    const profissional = prontuarioData?.profissional || {};

    return (
        <div className="space-y-6">
            {/* Dados Básicos */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Dados Básicos</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Nome Completo</label>
                        <p className="mt-1 text-sm text-gray-900">{profissional.nome_completo || 'Não informado'}</p>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Email</label>
                        <p className="mt-1 text-sm text-gray-900">{profissional.email || 'Não informado'}</p>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Telefone</label>
                        <p className="mt-1 text-sm text-gray-900">{profissional.telefone || 'Não informado'}</p>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Função</label>
                        <p className="mt-1 text-sm text-gray-900">{profissional.role || 'Não informado'}</p>
                    </div>
                </div>
            </div>

            {/* Documentos Profissionais */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Documentos Profissionais</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {profissional.crm && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700">CRM</label>
                            <p className="mt-1 text-sm text-gray-900">{profissional.crm}</p>
                        </div>
                    )}
                    {profissional.coren && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700">COREN</label>
                            <p className="mt-1 text-sm text-gray-900">{profissional.coren}</p>
                        </div>
                    )}
                    {profissional.crf && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700">CRF</label>
                            <p className="mt-1 text-sm text-gray-900">{profissional.crf}</p>
                        </div>
                    )}
                    {profissional.crefito && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700">CREFITO</label>
                            <p className="mt-1 text-sm text-gray-900">{profissional.crefito}</p>
                        </div>
                    )}
                </div>
            </div>

            {/* Informações Profissionais */}
            <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">Informações Profissionais</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {profissional.data_admissao && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Data de Admissão</label>
                            <p className="mt-1 text-sm text-gray-900">{formatDate(profissional.data_admissao)}</p>
                        </div>
                    )}
                    {profissional.tipo_contrato && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Tipo de Contrato</label>
                            <p className="mt-1 text-sm text-gray-900">{profissional.tipo_contrato}</p>
                        </div>
                    )}
                    {profissional.carga_horaria_semanal && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Carga Horária Semanal</label>
                            <p className="mt-1 text-sm text-gray-900">{profissional.carga_horaria_semanal} horas</p>
                        </div>
                    )}
                    {profissional.turno_trabalho && (
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Turno de Trabalho</label>
                            <p className="mt-1 text-sm text-gray-900">{profissional.turno_trabalho}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProfissionalDadosPessoaisTab;

